import React from 'react';
import PropTypes from 'prop-types';
import QueueAnim from 'rc-queue-anim';
import TweenOne from 'rc-tween-one';
import Children from 'rc-tween-one/lib/plugin/ChildrenPlugin';
import { Avatar } from 'antd';

import styles from './index.css';


TweenOne.plugins.push(Children);

/**
 * 分页数量显示动效组件
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2019-05-24 
 * Version: 1.0
 * Modify log:
 */
function PageSize(props) {

    const { pageNum, total } = props;

    return (
        <Avatar className={styles.pagination_tip}>
            <QueueAnim
                type={['bottom', 'top']}
                duration={500}
            >
                {
                    pageNum === total ?
                        <div style={{ marginTop: 21, lineHeight: '1em' }}>
                            <TweenOne
                                animation={{
                                    Children: { value: total, floatLength: 0 },
                                    duration: 1000,
                                }}
                            >
                                0
                        </TweenOne>
                        </div>
                        :
                        <div style={{ marginTop: 10 }}>
                            <div style={{ lineHeight: '1em' }}>
                                <TweenOne
                                    animation={{
                                        Children: { value: pageNum, floatLength: 0 },
                                        duration: 1000,
                                    }}
                                >
                                    0
                        </TweenOne>
                            </div>
                            <div style={{ height: 1, background: '#e8e8e8', margin: '4px 0' }} />
                            <div style={{ lineHeight: '1em' }}>
                                <TweenOne
                                    animation={{
                                        Children: { value: total, floatLength: 0 },
                                        duration: 1000,
                                    }}
                                >
                                    0
                        </TweenOne>
                            </div>
                        </div>
                }
            </QueueAnim>
        </Avatar>

    )

}

PageSize.defaultProps = {
    pageNum: 0,
    total: 0
}

PageSize.propTypes = {
    pageNum: PropTypes.number, //当前数据数量
    total: PropTypes.number, //总数量
}

export default PageSize;


// WEBPACK FOOTER //
// ./components/studentPhotoMng/PageSize.js